import { Download, ExternalLink, MessageCircle, Copy } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const downloadFile = async (url, filename) => {
  const r = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = href; a.download = filename || "archivo"; a.click();
  setTimeout(() => URL.revokeObjectURL(href), 60000);
};

export const CopilotActions = ({ actions, dark = false }) => {
  if (!actions?.length) return null;
  const btn = `inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold ${dark ? "bg-[#FFC629] text-[#0B0B0B]" : "bg-[#0B0B0B] text-[#FFC629]"}`;
  const copy = (t) => navigator.clipboard?.writeText(t).then(() => toast.success("Copiado"));
  return (
    <ul data-testid="copilot-actions" className="mt-2 space-y-1.5">
      {actions.map((a, i) => (
        <li key={i} data-testid="copilot-action" data-action-type={a.type} className={`text-[11px] rounded-lg px-2.5 py-1.5 ${a.ok ? (dark ? "bg-emerald-500/15 text-emerald-200" : "bg-emerald-50 text-emerald-800") : (dark ? "bg-red-500/15 text-red-200" : "bg-red-50 text-red-700")}`}>
          <div>{a.ok ? "✓" : "✕"} {a.label}</div>
          {a.items?.length > 0 && <ul className="mt-1 list-disc pl-4 space-y-0.5">{a.items.map((x) => <li key={x}>{x}</li>)}</ul>}
          {a.text && a.type !== "send_message" && <div className={`mt-1 italic ${dark ? "text-white/70" : ""}`}>“{a.text}”</div>}
          {(a.url || a.deep_link || a.link) && (
            <div className="mt-1.5 flex flex-wrap gap-1.5">
              {a.url && <button type="button" data-testid="copilot-action-download" onClick={() => downloadFile(a.url, a.filename).catch(() => toast.error("No se pudo descargar"))} className={btn}><Download size={12} /> Descargar {a.filename?.split(".").pop()?.toUpperCase()}</button>}
              {a.deep_link && <a data-testid="copilot-action-whatsapp" href={a.deep_link} target="_blank" rel="noreferrer" className={btn}><MessageCircle size={12} /> Abrir WhatsApp</a>}
              {a.link && <><a data-testid="copilot-action-link" href={a.link} target="_blank" rel="noreferrer" className={btn}><ExternalLink size={12} /> Abrir liga</a><button type="button" data-testid="copilot-action-copy" onClick={() => copy(a.link)} className={btn}><Copy size={12} /> Copiar</button></>}
            </div>
          )}
        </li>
      ))}
    </ul>
  );
};
